import { Button } from '@rentflowdev/ui'
import { useTranslation } from 'react-i18next'

interface LegalFooterProps {
	mode: 'login' | 'register'
}

export function LegalFooter({ mode }: LegalFooterProps) {
	const { t } = useTranslation()

	return (
		<div className="text-xs font-normal leading-5 text-(--color-muted-foreground) text-center max-w-[350px]">
			{t(`auth.legal.${mode}`)}{' '}
			<Button variant="link" className="text-xs">{t('auth.legal.terms')}</Button>
			{' '}{t('auth.legal.and')}{' '}
			<Button variant="link" className="text-xs">{t('auth.legal.privacy')}</Button>
		</div>
	)
}
